import { connect } from 'react-redux'

import {
  activateWebToPrintMode,
  endWebToPrintMode,
  toggleContentForPrint,
  markContentLoaded
} from '../actions/webToPrint'

const mapStateToProps = ({ webToPrint }) => ({
  ...webToPrint
})

const actionCreators = {
  activateWebToPrintMode,
  endWebToPrintMode,
  toggleContentForPrint,
  markContentLoaded
}

export default connect(
  mapStateToProps,
  actionCreators
)



// WEBPACK FOOTER //
// ./src/hocs/withWebToPrint.js